import React from 'react'

import { Suspense } from '~/components/elements/Suspense'
import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'

import { CoreMembersList } from './components/CoreMembersList'
import { useMainQuery } from './hooks/useMainQuery'

export const CoreMembersListPage = () => {
  const { isLoading } = useMainQuery()

  useLogEventOnMount('Access to core member list')

  return (
    <Suspense loading={isLoading}>
      <CoreMembersList />
    </Suspense>
  )
}
